import { EstimatesPermissions } from '@payaca/permissions/estimates/estimates.permissions';
import { userHasRequiredPermission } from '@payaca/permissions/permissions.utils';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { getUserRoles } from '../../../utils/stateAccessors';
import DefaultEstimateItemsSection from './DefaultEstimateItemsSection';
import PreferredProductsSection from './PreferredProductsSection';

const CompanySettingsEstimates: FC = () => {
  const userRoles = useSelector(getUserRoles);

  const canViewPreferredProducts = userHasRequiredPermission(userRoles, [
    EstimatesPermissions.MANAGE_PREFERRED_PRODUCTS,
  ]);
  const canViewDefaultItems = userHasRequiredPermission(userRoles, [
    EstimatesPermissions.GET_DEFAULT_ITEMS,
  ]);

  return (
    <>
      {canViewPreferredProducts && <PreferredProductsSection />}
      {canViewDefaultItems && <DefaultEstimateItemsSection />}
    </>
  );
};

export default CompanySettingsEstimates;
